import { DatePipe, TitleCasePipe } from '@angular/common';
import { Component, computed, effect, Signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { iUser } from 'src/app/interfaces/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoadscreenComponent } from '../loadscreen/loadscreen.component';
import { UserService } from 'src/app/services/user.service';
import { BillingAddress } from 'src/app/interfaces/billing-address';
import { ToastService } from 'src/app/services/toast.service';
import { CacheService } from 'src/app/services/cache.service';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    ReactiveFormsModule,
    TitleCasePipe,
    DatePipe,
    LoadscreenComponent
  ]
})
export class UserFormComponent {

  public user: Signal<iUser> = computed(() => this.authService.user());
  public isSubmitting: boolean = false;

  billingAddressForm = new FormGroup({
    first_name: new FormControl('', { validators: [Validators.required] }),
    last_name: new FormControl('', { validators: [Validators.required] }),
    company: new FormControl(''),
    address_1: new FormControl('', { validators: [Validators.required] }),
    address_2: new FormControl(''),
    city: new FormControl('', { validators: [Validators.required] }),
    state: new FormControl(''),
    postcode: new FormControl('', { validators: [Validators.required] }),
    country: new FormControl('', { validators: [Validators.required] }),
    email: new FormControl('', { validators: [Validators.required, Validators.email] }),
    phone: new FormControl('', { validators: [Validators.required] })
  });


  userDataHandler = effect(() => {
    const user = this.user();
    if (user && user.billing_address) {
      const BillingAddress = user.billing_address;
      this.billingAddressForm.patchValue({ ...BillingAddress });
    }
  });


  constructor(
    private authService: AuthenticationService,
    private userServices: UserService,
    private toastService: ToastService,
    private cacheService: CacheService
  ) { }


  /**
   * Save the user data
   */
  public saveUserData() {
    this.isSubmitting = true;

    /* Save billing address */
    const billingAddress = this.billingAddressForm.value as BillingAddress;
    this.userServices.saveUserBillingAddress(billingAddress).subscribe({
      next: (data: any) => {
        if(data.success) {
          this.toastService.presentToast('Booking alias informationen er gemt', 'success');

          const userData = this.user();
          userData.billing_address = billingAddress;
          this.authService.updateUserData(userData);

          /* Clear the cache for old order-data */
          this.cacheService.clearCache();
        }else {
          this.toastService.presentToast(data.data.message, 'danger');
        }
        this.isSubmitting = false;
      },
      error: (error) => {
        this.toastService.presentToast('Error saving the data: ' + error, 'danger');
        this.isSubmitting = false;
      }
    });
  }

}
